export const PLANGROWTH = 'Plan Growth';
export const NEW = 'Nuevo';
export const LOCK = 'Bloqueo';
export const LOW = 'Bajo';
export const MEDIUM = 'Medio';
export const GOOD = 'Bueno';
export const OUTSTANDING = 'Destacado';
